import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MeetingKey } from '#meeting/keys';
import { UserKey } from '#user/keys';

import type { GroupEditData } from './groupService';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useEditGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: GroupEditData) => GroupService.editGroup(data).then((response) => response.data),

    onSettled: (data, error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUPS],
      });
      void queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUP, variables.id],
      });
      void queryClient.invalidateQueries({
        queryKey: [GroupKey.GROUP_USERS, variables.id],
      });

      if (variables.schedule) {
        void queryClient.invalidateQueries({
          queryKey: [GroupKey.ASSIGNED_GROUPS_INFINITE],
        });
        void queryClient.invalidateQueries({
          queryKey: [GroupKey.GROUP_MEETINGS_INFINITE],
        });
        void queryClient.invalidateQueries({
          queryKey: [MeetingKey.MEETINGS],
        });
        void queryClient.invalidateQueries({
          queryKey: [MeetingKey.MEETINGS_INFINITE],
        });
      }

      variables.memberChanges?.forEach((memberChange) => {
        memberChange.userIds?.forEach((userId) => {
          void queryClient.invalidateQueries({
            queryKey: [UserKey.USER_GROUPS, userId],
          });
        });
      });
    },
  });
}
